import Head from '@bridebook/web/app-basic/components/head/head';
import { isEmpty } from 'ramda';
import { FC, memo } from 'react';
import type { Market } from '@bridebook/toolbox/src/gazetteer';
import { SearchFacet } from '@bridebook/toolbox/src/seo-facets/get-seo-data';
import type { IUISupplier, Slug } from '@bridebook/toolbox/src/types';
import { useSearchMetaDesc } from '@bridebook/web/app-shared/lib/search/hooks/use-search-meta-desc';
import { ILocationData, ISearchPageQuery } from '@bridebook/web/app-shared/lib/search/types';
import { getImgixUrl } from '@bridebook/web/app-shared/lib/utils/get-imgix-url';
import { IMAGES_BASE_URL } from '@bridebook/toolbox/src/buildImageUrl';

interface IProps {
  actualCategory: Slug | '';
  area: string;
  facetsContent: SearchFacet;
  facetsParams: string[];
  fullQuery: ISearchPageQuery;
  list: IUISupplier[];
  locationData: ILocationData | null;
  market: Market;
  pageTitle: string;
}

const SearchHead: FC<IProps> = ({
  actualCategory,
  list,
  area,
  locationData,
  facetsContent,
  facetsParams,
  pageTitle,
  market,
}) => {
  const metaDesc = useSearchMetaDesc({ actualCategory, area, list, market });
  // if there isn't any thumbnail created we are using default meta image
  const imageUrl = getImgixUrl(list[0]?.thumbnail) || `${IMAGES_BASE_URL}/assets/bblogo_fb.jpg`;
  const indexingSupported =
    !!locationData?.index &&
    market.getLocaleFlags()?.indexable === true &&
    list.length >= 3 &&
    isEmpty(facetsParams); // don't apply location-info indexing settings in case there are facets present.

  // if override exists - use override, otherwise fallback to usual
  const isIndexable = facetsContent ? Boolean(facetsContent.index) : indexingSupported;
  return (
    <Head
      title={pageTitle}
      description={metaDesc}
      ogTitle={pageTitle}
      ogDescription={metaDesc}
      isIndexable={isIndexable}
      canonicalUrlOverride={facetsContent?.canonical}
      facetsParams={facetsParams}
      ogImage={imageUrl}
      plainOgTitle={false}
    />
  );
};

export default memo(SearchHead);
